var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 4C7.5 3.44772 7.94772 3 8.5 3H15.5C16.0523 3 16.5 3.44772 16.5 4C16.5 4.55228 16.0523 5 15.5 5H13V8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8V5H8.5C7.94772 5 7.5 4.55228 7.5 4Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12C10.3431 12 9 13.3431 9 15C9 16.6569 10.3431 18 12 18C13.6569 18 15 16.6569 15 15C15 13.3431 13.6569 12 12 12ZM7 15C7 12.2386 9.23858 10 12 10C14.7614 10 17 12.2386 17 15C17 17.7614 14.7614 20 12 20C9.23858 20 7 17.7614 7 15Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12C15 11.4477 15.4477 11 16 11H20C20.5523 11 21 11.4477 21 12V19C21 19.5523 20.5523 20 20 20H16C15.4477 20 15 19.5523 15 19V12ZM17 13V18H19V13H17Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.14935 7.47427C8.33156 7.17945 8.65342 7 9 7H15C15.3466 7 15.6684 7.17945 15.8507 7.47427C16.0329 7.76909 16.0494 8.13723 15.8944 8.44721L14.3944 11.4472C14.225 11.786 13.8788 12 13.5 12H10.5C10.1212 12 9.77496 11.786 9.60557 11.4472L8.10557 8.44721C7.95058 8.13723 7.96714 7.76909 8.14935 7.47427ZM10.618 9L11.118 10H12.882L13.382 9H10.618Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 11.4477 3.44772 11 4 11H8C8.55228 11 9 11.4477 9 12V19C9 19.5523 8.55228 20 8 20H4C3.44772 20 3 19.5523 3 19V12ZM5 13V18H7V13H5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValve);
export default __webpack_public_path__ + "static/media/valve.55f86547bf275463d46c78de99eb770d.svg";
export { ForwardRef as ReactComponent };